/**
 * inyourplace-subclip-selector-server
 * Server to generate sports graphics
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: r.hutter@moovit.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Subclip from './Subclip';

/**
 * The Cart model module.
 * @module model/Cart
 * @version 1.0.0
 */
class Cart {
    /**
     * Constructs a new <code>Cart</code>.
     * @alias module:model/Cart
     */
    constructor() { 
        
        Cart.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>Cart</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Cart} obj Optional instance to populate.
     * @return {module:model/Cart} The populated <code>Cart</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Cart();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('assets')) {
                obj['assets'] = ApiClient.convertToType(data['assets'], ['String']);
            }
            if (data.hasOwnProperty('cartStatus')) {
                obj['cartStatus'] = ApiClient.convertToType(data['cartStatus'], 'String');
            }
            if (data.hasOwnProperty('created')) {
                obj['created'] = ApiClient.convertToType(data['created'], 'Date');
            }
            if (data.hasOwnProperty('emailAdresses')) {
                obj['emailAdresses'] = ApiClient.convertToType(data['emailAdresses'], 'String');
            }
            if (data.hasOwnProperty('hiddenAssets')) {
                obj['hiddenAssets'] = ApiClient.convertToType(data['hiddenAssets'], ['String']);
            }
            if (data.hasOwnProperty('lastMod')) {
                obj['lastMod'] = ApiClient.convertToType(data['lastMod'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('subclips')) {
                obj['subclips'] = ApiClient.convertToType(data['subclips'], [Subclip]);
            }
            if (data.hasOwnProperty('user')) {
                obj['user'] = ApiClient.convertToType(data['user'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>Cart</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Cart</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['id'] && !(typeof data['id'] === 'string' || data['id'] instanceof String)) {
            throw new Error("Expected the field `id` to be a primitive type in the JSON string but got " + data['id']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['assets'])) {
            throw new Error("Expected the field `assets` to be an array in the JSON data but got " + data['assets']);
        }
        // ensure the json data is a string
        if (data['cartStatus'] && !(typeof data['cartStatus'] === 'string' || data['cartStatus'] instanceof String)) {
            throw new Error("Expected the field `cartStatus` to be a primitive type in the JSON string but got " + data['cartStatus']);
        }
        // ensure the json data is a string
        if (data['emailAdresses'] && !(typeof data['emailAdresses'] === 'string' || data['emailAdresses'] instanceof String)) {
            throw new Error("Expected the field `emailAdresses` to be a primitive type in the JSON string but got " + data['emailAdresses']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['hiddenAssets'])) {
            throw new Error("Expected the field `hiddenAssets` to be an array in the JSON data but got " + data['hiddenAssets']);
        }
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }
        if (data['subclips']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['subclips'])) {
                throw new Error("Expected the field `subclips` to be an array in the JSON data but got " + data['subclips']);
            }
            // validate the optional field `subclips` (array)
            for (const item of data['subclips']) {
                Subclip.validateJSON(item);
            };
        }
        // ensure the json data is a string
        if (data['user'] && !(typeof data['user'] === 'string' || data['user'] instanceof String)) {
            throw new Error("Expected the field `user` to be a primitive type in the JSON string but got " + data['user']);
        }

        return true;
    }


}



/**
 * @member {String} id
 */
Cart.prototype['id'] = undefined;

/**
 * @member {Array.<String>} assets
 */
Cart.prototype['assets'] = undefined;

/**
 * @member {module:model/Cart.CartStatusEnum} cartStatus
 */
Cart.prototype['cartStatus'] = undefined;

/**
 * @member {Date} created
 */
Cart.prototype['created'] = undefined;

/**
 * @member {String} emailAdresses
 */
Cart.prototype['emailAdresses'] = undefined;

/**
 * @member {Array.<String>} hiddenAssets
 */
Cart.prototype['hiddenAssets'] = undefined;

/**
 * @member {Number} lastMod
 */
Cart.prototype['lastMod'] = undefined;

/**
 * @member {String} name
 */
Cart.prototype['name'] = undefined;

/**
 * @member {Array.<module:model/Subclip>} subclips
 */
Cart.prototype['subclips'] = undefined;

/**
 * @member {String} user
 */
Cart.prototype['user'] = undefined;





/**
 * Allowed values for the <code>cartStatus</code> property.
 * @enum {String}
 * @readonly
 */
Cart['CartStatusEnum'] = {

    /**
     * value: "NEW"
     * @const
     */
    "NEW": "NEW",

    /**
     * value: "EMAILSENT"
     * @const
     */
    "EMAILSENT": "EMAILSENT",

    /**
     * value: "INPROGRESS"
     * @const
     */
    "INPROGRESS": "INPROGRESS",

    /**
     * value: "SUBCLIPSSELECTED"
     * @const
     */
    "SUBCLIPSSELECTED": "SUBCLIPSSELECTED",

    /**
     * value: "APPROVED"
     * @const
     */
    "APPROVED": "APPROVED",

    /**
     * value: "RESTORED"
     * @const
     */
    "RESTORED": "RESTORED",

    /**
     * value: "RENDERING"
     * @const
     */
    "RENDERING": "RENDERING",

    /**
     * value: "LOCKED"
     * @const
     */
    "LOCKED": "LOCKED"
};



export default Cart;

